// extracted by mini-css-extract-plugin
export default {"paymentsBlock":"_300Bc","paymentImg":"cuRY6"};